module.exports = __webpack_public_path__ + "img/logo.d2762d8d.png";